import { render, staticRenderFns } from "./cart-confirmation.vue?vue&type=template&id=5d61b366&lang=pug&"
import script from "./cart-confirmation.vue?vue&type=script&lang=js&"
export * from "./cart-confirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports